import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import {
  AlarmClockCheck,
  ArrowDownRight,
  ArrowUpRight,
  BarChart3,
  Calendar,
  Calendar1,
  CalendarDays,
  CheckCircle2,
  ChevronDown,
  CircleDollarSign,
  Clock,
  Eye,
  FileDown,
  FileText,
  FolderTree,
  IdCard,
  KanbanIcon,
  ListIcon,
  Mail,
  Minus,
  Paperclip,
  Pencil,
  PhoneCall,
  Plus,
  PlusIcon,
  ShieldX,
  Tag,
  TrendingUp,
  User,
} from "lucide-react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { motion } from "framer-motion";
import DynamicFilter from "../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../component/table/customize-table";
import LayoutTopIcon from "../../../component/icons/layout-top";
import XCloseIcon from "../../../component/icons/x-close";
import { CustomDropdown } from "../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../component/ui/dropdown/CustomDropdownMenuList";
import Tooltip from "../../../component/ui/tooltip";
import FileCode1Icon from "../../../component/icons/file-code-1";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFooter,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import ChevronDownIcon from "../../../component/icons/chevron-down";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router";
// import AddWalletTransaction from "./add-wallet-transaction/add-wallet-transaction";
import DashboardKPI from "../../../component/dashboard-kpi/DashboardKPI";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
// import { Funnel } from "recharts";
// import { Funnel } from "recharts";
// import { Funnel } from "recharts";
// FIX: Import like this
import FunnelModule from "highcharts/modules/funnel";
import DealList from "./Deals";
import StatusChip from "../../../component/ui/chip/status";

// changes
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge.js";



const Card = ({ className = "", children }) => (
  <div
    className={`w-full border border-[#E1E4EA] shadow rounded-[14px] flex flex-col border-slate-200/60 1darkborder-slate-800 bg-white 1darkbg-slate-900 ${className}`}
  >
    {children}
  </div>
);
const CardHeader = ({ className = "", children }) => (
  <div
    className={`pb-5 border-b border-slate-100 1darkborder-slate-800 ${className}`}
  >
    {children}
  </div>
);
const CardTitle = ({ className = "", children }) => (
  <h3
    className={`text-lg md:text-xl font-semibold tracking-tight ${className}`}
  >
    {children}
  </h3>
);
const CardContent = ({ className = "", children }) => (
  <div className={` w-full h-full ${className}`}>{children}</div>
);

// Initialize the module safely
if (typeof FunnelModule === "function") {
  FunnelModule(Highcharts);
}
if (typeof HighchartsMore === "function") {
  HighchartsMore(Highcharts);
  SolidGauge(Highcharts);
}

const TeamDashbaord = () => {
  // let data = "";
  const apiCall = useApiCall();
  const router = useNavigate();
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(false);
  const [activeChart, setActiveChart] = useState("New Leads vs Converted");
  const [selectedMonths, setSelectedMonths] = useState(6);

  const getKPIData = async () => {
    setKPILoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/lead-overview-kpi?view=myleads`,
      });
      setKPIData(resp?.data);
      setKPILoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getDistributionData();
  }, []);

  // BAR CHART
  const [distributionData, setDistributionData] = useState([]);
  const [distributionLoading, setDistributionLoading] = useState(false);

  const getDistributionData = async () => {
    setDistributionLoading(false);
    try {
      const res = await apiCall({
        method: "get",
        url: "leads/lead-overview-by-bar?view=myleads",
      });
      setDistributionData(res.data);
    } catch (error) {
      console.warn("Error fetching distribution data:", error);
    } finally {
      setDistributionLoading(true);
    }
  };

  const BarOptions = {
    chart: {
      type: "bar",
      backgroundColor: "transparent",
      height: 320,
    },
    title: { text: "" },
    xAxis: {
      categories: distributionData?.map((d) => d.status),
      title: { text: null },
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280", fontWeight: "500" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Number of Leads", align: "high" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    tooltip: {
      valueSuffix: " leads",
      backgroundColor: "#ffffff",
      borderColor: "#E5E7EB",
      style: { color: "#111827" },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        dataLabels: {
          enabled: true,
          style: { color: "#111827", fontWeight: "500" },
        },
      },
      series: {
        pointPadding: 0.2,
        groupPadding: 0.1,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Leads",
        data: distributionData?.map((d) => d.total),
        colorByPoint: true,
        colors: ["#3B82F6", "#3B82F6", "#3B82F6", "#3B82F6", "#3B82F6"],
      },
    ],
    legend: { enabled: false },
    credits: { enabled: false },
  };

  const trends = [
    {
      annual_leave: 46,
      casual_leave: 0,
      month: "Jan",
      other_leave: 8,
      sick_leave: 0,
    },
    {
      annual_leave: 46,
      casual_leave: 0,
      month: "Feb",
      other_leave: 8,
      sick_leave: 0,
    },
    {
      annual_leave: 0,
      casual_leave: 10,
      month: "March",
      other_leave: 80,
      sick_leave: 3,
    },
    {
      annual_leave: 9,
      casual_leave: 0,
      month: "April",
      other_leave: 7,
      sick_leave: 1,
    },
    {
      annual_leave: 9,
      casual_leave: 0,
      month: "May",
      other_leave: 7,
      sick_leave: 1,
    },
    {
      annual_leave: 9,
      casual_leave: 0,
      month: "June",
      other_leave: 7,
      sick_leave: 1,
    },
  ];

  const lineOptions = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 300,
    },
    title: { text: "" },
    xAxis: {
      categories: trends?.map((d) => d?.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      min: 0,
      title: { text: "" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    legend: { align: "right", verticalAlign: "top" },
    plotOptions: {
      column: {
        stacking: "normal",
        borderRadius: 6,
        pointWidth: 35,
      },
    },
    tooltip: {
      shared: true, // show all series together
      useHTML: true,
      formatter: function () {
        const d = trends[this.points[0].point.index];
        return `
          <b>${d?.month}</b><br/>
          Casual: <b>${d?.casual_leave}</b><br/>
          Sick: <b>${d?.sick_leave}</b><br/>
          Annual: <b>${d?.annual_leave}</b><br/>
          Other: <b>${d?.other_leave}</b>
        `;
      },
    },
    series: [
      {
        name: "Casual",
        data: trends?.map((d) => d?.casual_leave || 0),
        color: "#B18AE3",
        stack: "leaves",
      },
      {
        name: "Sick",
        data: trends?.map((d) => d?.sick_leave || 0),
        color: "#D89CCC",
        stack: "leaves",
      },
      {
        name: "Annual",
        data: trends?.map((d) => d?.annual_leave || 0),
        color: "#93B57B",
        stack: "leaves",
      },
      {
        name: "Other",
        data: trends?.map((d) => d?.other_leave || 0),
        color: "#E0B395",
        stack: "leaves",
      },
    ],
    credits: { enabled: false },
  };

  // Total Incomes

  const totalIncome = [
    {
      sale: 17000,
      month: "Jan",
    },
    {
      sale: 10000,
      month: "Feb",
    },
    {
      sale: 22000,
      month: "Mar",
    },
    {
      sale: 12200,
      month: "Apr",
    },
    {
      sale: 14000,
      month: "May",
    },
    {
      sale: 15000,
      month: "Jun",
    },
  ];

  const totalIncomeOptions = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 300,
    },
    title: { text: "" },
    xAxis: {
      categories: totalIncome?.map((d) => d?.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      min: 0,
      title: { text: "" },
      gridLineColor: "#DCDCDC",
      gridLineDashStyle: "LongDash",
      labels: { style: { color: "#6B7280" } },
      tickInterval: 5000,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        // stacking: "normal",
        borderRadius: 10,
        pointWidth: 35,
        states: {
          hover: {
            enabled: true,
            brightness: 0,
          },
          inactive: {
            opacity: 0.9,
          },
        },
      },
    },
    tooltip: {
      shared: true, // show all series together
      useHTML: true,
      formatter: function () {
        const d = totalIncome[this.points[0].point.index];
        return `
          <b>${d?.month}</b><br/>
          Sale: <b>${d?.sale}</b><br/>
        `;
      },
    },
    series: [
      {
        name: "",
        type: "column",
        data: totalIncome?.map((d) => {
          const value = d?.sale || 0;

          let color = "#FF7F50"; // default for >= 20k

          if (value < 15000) color = "#E1E4EA";
          else if (value < 20000) color = "#0057FB";

          return {
            y: value,
            color: color,
          };
        }),
        // stack: "Total Income",
        borderRadius: 10,
        pointWidth: 35,
      },
    ],
    credits: { enabled: false },
  };

  // Total Orders

  const totalOrders = [
    {
      target: 17000,
      order: 15000,
      month: "Jan",
    },
    {
      target: 10000,
      order: 12000,
      month: "Feb",
    },
    {
      target: 22000,
      order: 19000,
      month: "Mar",
    },
    {
      target: 12200,
      order: 12000,
      month: "Apr",
    },
  ];

  const totalOrdersOptions = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 300,
    },
    title: { text: "" },
    xAxis: {
      categories: totalOrders?.map((d) => d?.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      min: 0,
      title: { text: "" },
      gridLineColor: "#DCDCDC",
      gridLineDashStyle: "LongDash",
      labels: { style: { color: "#6B7280" } },
      tickInterval: 5000,
    },
    legend: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 10,
        pointWidth: 35,
        groupPadding: 0, // gap between each month group
        pointPadding: 0.09, // gap between columns in the same month
        states: {
          hover: { enabled: true, brightness: 0 },
          inactive: { opacity: 0.9 },
        },
      },
    },
    tooltip: {
      shared: false, // separate tooltip per column
      useHTML: true,
      formatter: function () {
        const point = this.point;
        const d = totalOrders[point.index];
        if (point.series.name === "Target") {
          //  <b>${d.month}</b><br/>
          return `
          
          Company Target: <b>${d.target}</b>
        `;
        } else {
          return `
         
          Order: <b>${d.order}</b>
        `;
        }
      },
    },
    series: [
      {
        name: "Target",
        type: "column",
        data: totalOrders?.map((d) => ({
          y: d.target,
          color: "#DBEAFE",
        })),
        borderRadius: 10,
        pointWidth: 35,
      },
      {
        name: "Order",
        type: "column",
        data: totalOrders?.map((d) => ({
          y: d.order,
          color: "#0057FB",
        })),
        // data: totalIncome?.map((d) => {
        //     const value = d?.sale || 0;

        //     let color = "#FF7F50"; // default for >= 20k

        //     if (value < 15000) color = "#E1E4EA";
        //     else if (value < 20000) color = "#0057FB";

        //     return {
        //       y: value,
        //       color: color,
        //     };
        //   }),
        borderRadius: 10,
        pointWidth: 35,
      },
    ],
    credits: { enabled: false },
  };

  // Funnel Chart

  const funnelData = [
    {
      name: "Leads",
      value: 1340,
    },
    {
      name: "Sales Call",
      value: 1340,
    },
    {
      name: "Follow-up",
      value: 1340,
    },
    {
      name: "Follow-up",
      value: 1340,
    },
    {
      name: "Sales",
      value: 1340,
    },
  ];

  const funnelOptions = {
    chart: {
      type: "funnel",
      height: 300,
      width: null,
    },

    title: {
      text: "",
    },

    plotOptions: {
      series: {
        height: "100%",
        reversed: false,
        minSize: "70%",
        width: "100%",

        borderWidth: 8,
        borderColor: "#ffffff",

        neckWidth: "30%",
        neckHeight: "0%",

        dataLabels: {
          enabled: true,
          inside: true,
          align: "center",
          verticalAlign: "middle",
          crop: false,
          overflow: "allow",
          formatter: function () {
            return `${this.point.name}: ${this.point.y}`; // 👈 show name + value
          },
          style: {
            whiteSpace: "nowrap",
            fontSize: "15px",
            fontWeight: 600,
            textOutline: "none",
          },
        },

        states: {
          hover: { enabled: true, brightness: 0 },
          inactive: { opacity: 0.9 },
        },
      },
    },

    colors: ["#dbe9ff", "#ffece2", "#e6e9ef", "#ffe1e4", "#d9f3e2"],

    series: [
      {
        name: "Funnel",
        data: funnelData?.map((item) => [item.name, item.value]), // 👈 your data
      },
    ],
    credits: { enabled: false },
  };

  // const value = 70.8;
  // const gaugeOptions = {
  //   chart: {
  //     type: "solidgauge",
  //     height: "70%",
  //   },

  //   title: null,

  //   pane: {
  //     startAngle: -90,
  //     endAngle: 90,
  //     background: [
  //       {
  //         outerRadius: "100%",
  //         innerRadius: "80%",
  //         backgroundColor: "#4dc3ff",
  //         borderWidth: 0,
  //       },
  //       {
  //         outerRadius: "80%",
  //         innerRadius: "60%",
  //         backgroundColor: "#6cc04a",
  //         borderWidth: 0,
  //       },
  //       {
  //         outerRadius: "60%",
  //         innerRadius: "40%",
  //         backgroundColor: "#f3b222",
  //         borderWidth: 0,
  //       },
  //       {
  //         outerRadius: "40%",
  //         innerRadius: "20%",
  //         backgroundColor: "#0056ff",
  //         borderWidth: 0,
  //       },
  //     ],
  //   },

  //   tooltip: { enabled: false },

  //   yAxis: {
  //     min: 0,
  //     max: 100,
  //     lineWidth: 0,
  //     tickPositions: [],
  //   },

  //   plotOptions: {
  //     solidgauge: {
  //       rounded: true,
  //     },
  //   },

  //   series: [
  //     {
  //       name: "Sales Growth",
  //       data: [
  //         {
  //           color: "#4dc3ff",
  //           radius: "100%",
  //           innerRadius: "80%",
  //           y: value,
  //         },
  //         {
  //           color: "#6cc04a",
  //           radius: "80%",
  //           innerRadius: "60%",
  //           y: value,
  //         },
  //         {
  //           color: "#f3b222",
  //           radius: "60%",
  //           innerRadius: "40%",
  //           y: value,
  //         },
  //         {
  //           color: "#0056ff",
  //           radius: "40%",
  //           innerRadius: "20%",
  //           y: value,
  //         },
  //       ],
  //       dataLabels: {
  //         useHTML: true,
  //         format: `
  //           <div style="text-align:center;">
  //             <span style="font-size:32px;font-weight:600;color:#000;">
  //               ${value}%
  //             </span><br/>
  //             <span style="font-size:16px;color:#666;">
  //               Sales Growth
  //             </span>
  //           </div>
  //         `,
  //         y: -20,
  //       },
  //     },
  //   ],
  // };

  const users = [
    {
      name: "John",
      image: "",
    },
    {
      name: "Alcie",
      image: "",
    },
    {
      name: "MArk",
      image: "",
    },
    {
      name: "Jis",
      image: "",
    },
    {
      name: "Pols",
      image: "",
    },
  ];

  const [showAll, setShowAll] = useState(false);
  const visibleUsers = showAll ? users : users.slice(0, 2);
  const hiddenCount = users.length - 3;

  const [openAccountIndex, setOpenAccountIndex] = useState(0);
  const [openTodoIndex, setOpenTodoIndex] = useState(0);

  // final chart

  // const options = {
  //   chart: {
  //     plotBackgroundColor: null,
  //     plotBorderWidth: 0,
  //     plotShadow: false,

  //     height: 300,
  //   },
  //   // title: {
  //   //   text: "Browser<br>shares<br>January<br>2022",
  //   //   align: "center",
  //   //   verticalAlign: "middle",
  //   //   y: 60,
  //   //   style: {
  //   //     fontSize: "1.1em",
  //   //   },
  //   // },
  //   title:"",
  //   subtitle: {
  //         text: `<div style="text-align:center">
  //             <span style="font-size:38px;font-weight:600">78.3%</span><br/>
  //            <span style="font-size:16px;color:#444">Sales Growth</span>
  //          </div>`,
  //         useHTML: true,
  //         verticalAlign: "middle",
  //         y: 20,
  //       },
  //   tooltip: {
  //     pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
  //   },
  //   accessibility: {
  //     point: {
  //       valueSuffix: "%",
  //     },
  //   },
  //   plotOptions: {
  //     pie: {
  //       dataLabels: {
  //         enabled: false,
  //         distance: -50,
  //         style: {
  //           fontWeight: "bold",
  //           color: "white",
  //         },
  //       },
  //       startAngle: -90,
  //       endAngle: 90,
  //       center: ["50%", "75%"],
  //       size: "110%",
  //     },
  //   },
  //   series: [
  //     {
  //       type: "pie",
  //       innerSize: "70%",
  //       name: "Sales growth",
  //       data: [
  //         { name: "Rank By monday", y: 73.86 }, // Rounded START
  //         { name: "Resume Rrofs", y: 11.97 },
  //         { name: "fix Profs", y: 5.52 },
  //         { name: "Shopify corps", y: 2.98 },
  //         { name: "Shopirfy profs ", y: 1.9 },
  //         { name: "Other", y: 3.77 }, // Rounded END
  //       ],

  //     },
  //   ],
  //   credits: { enabled: false },
  // };

  // const chartComponentRef = useRef(null);

   const options = {
    chart: {
      type: "pie",
      height: 300, // <<< your height
    },

    title: {
      text: `
        <div style="text-align:center">
          <span style="font-size:38px;font-weight:600">78.3%</span><br/>
          <span style="font-size:16px;color:#444">Sales Growth</span>
        </div>
      `,
      useHTML: true,
      verticalAlign: "middle",
      y: 20,
    },

    credits: { enabled: false },

    tooltip: {
      useHTML: true, // IMPORTANT
      outside: false,

      style: {
        zIndex: 9999, // <<< FIX: Keep tooltip on top
      },
      enabled: true,

      headerFormat: `
    <span style="font-size:13px;font-weight:600;">
      Sales Growth
    </span><br/>
  `,

      pointFormat: `
    <span style="color:{point.color}">\u25CF</span>
    <b>{point.name}</b>: {point.y}%
  `,
    },

    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        size: "130%",
        innerSize: "75%",
      },
      series: {
        borderRadius: 8,
        dataLabels: [{ enabled: false }],
      },
    },

    series: [
      {
        type: "pie",
        name: "Sales growth",
        colorByPoint: true,
         series: {
    borderRadius: "50%", // <<< rounds the ends!
  },
        colors: [
      "#47C2FF", // Rank By Monday
      "#72BE49", // Resume Profs
      "#F6B51E", // Fix Profs
      "#0057FB", // Shopify Corps
      "#A855F7", // Shopify Profs
      "#9CA3AF", // Other
    ],
        data: [
          { name: "Rank By Monday", y: 43.86 },
          { name: "Resume Profs", y: 19.97 },
          { name: "Fix Profs", y: 15.52 },
          { name: "Shopify Corps", y: 22.98 },
          // { name: "Other", y: 3.77 },
        ],
      },
    ],
  };
  return (
    <>
      <div className="pt-[20px] overflow-hidden h-full">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          <TableCard className={"!p-[15px]  h-full overflow-hidden"}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 ">
              {/* Total Income */}
              <Card className="col-span-1 md:col-span-3  p-5 min-h-[450px] max-h-[520px] border border-[#E1E4EA] shadow rounded-[10px]">
                <CardHeader className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Total Income
                   <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                  <div className="text-sm  font-normal text-black/60">
                    View your income in a certain period of time
                  </div>
                </CardHeader>

                <div className="my-6">
                  <div className="text-4xl font-medium text-[#0E121B]">
                    50,0000
                  </div>

                  {true && (
                    <div className="flex items-center  gap-1 mt-4">
                      <span
                        className={`inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${
                          true
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {true ? (
                          <>
                            {" "}
                            <Plus className="w-3 h-3 " />{" "}
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          </>
                        ) : (
                          <>
                            <Minus className="w-3 h-3 " />{" "}
                            <ArrowDownRight className="w-3 h-3 mr-1" />
                          </>
                        )}
                        2.7
                      </span>

                      <span className="text-sm  font-normal text-black/60 leading-normal">
                        Vs Last Month
                      </span>
                    </div>
                  )}
                </div>
                <CardContent>
                  {true ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={totalIncomeOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* Total Leads */}
              <Card className="col-span-1 md:col-span-3  p-5 min-h-[450px] max-h-[520px] border border-[#E1E4EA] shadow rounded-[10px]">
                <CardHeader className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Total Leads
                    <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                  <div className="text-sm  font-normal text-black/60">
                    View your income in a certain period of time
                  </div>
                </CardHeader>

                <div className="my-6">
                  <div className="text-4xl font-medium text-[#0E121B]">
                    1340
                  </div>

                  {true && (
                    <div className="flex items-center  gap-1 mt-4">
                      <span
                        className={`inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${
                          false
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {false ? (
                          <>
                            {" "}
                            <Plus className="w-3 h-3 " />{" "}
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          </>
                        ) : (
                          <>
                            <Minus className="w-3 h-3 " />{" "}
                            <ArrowDownRight className="w-3 h-3 mr-1" />
                          </>
                        )}
                        2.1
                      </span>

                      <span className="text-sm  font-normal text-black/60 leading-normal">
                        Vs Last Month
                      </span>
                    </div>
                  )}
                </div>
                <CardContent>
                  {true ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={funnelOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* Total Orders */}
              <Card className="col-span-1 md:col-span-3  p-5 min-h-[450px] max-h-[520px] border border-[#E1E4EA] shadow rounded-[10px]">
                <CardHeader className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Total Orders
                     <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                  <div className="text-sm  font-normal text-black/60">
                    View your income in a certain period of time
                  </div>
                </CardHeader>

                <div className="my-6">
                  <div className="text-4xl font-medium text-[#0E121B]">
                    $25,000
                  </div>

                  {true && (
                    <div className="flex items-center  gap-1 mt-4">
                      <span
                        className={`inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${
                          true
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {true ? (
                          <>
                            {" "}
                            <Plus className="w-3 h-3 " />{" "}
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          </>
                        ) : (
                          <>
                            <Minus className="w-3 h-3 " />{" "}
                            <ArrowDownRight className="w-3 h-3 mr-1" />
                          </>
                        )}
                        3.7
                      </span>

                      <span className="text-sm  font-normal text-black/60 leading-normal">
                        Vs Last Year
                      </span>
                    </div>
                  )}
                </div>
                <CardContent>
                  {true ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={totalOrdersOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* Total ChargeBAck */}

              <Card className="col-span-1 md:col-span-3  p-5 min-h-[450px] max-h-[520px] border border-[#E1E4EA] shadow rounded-[10px]">
                <CardHeader className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Total ChargeBack
                     <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                  <div className="text-sm  font-normal text-black/60">
                    View your income in a certain period of time
                  </div>
                </CardHeader>

                <div className="my-6">
                  <div className="text-4xl font-medium text-[#0E121B]">
                    $500
                  </div>

                  {true && (
                    <div className="flex items-center  gap-1 mt-4">
                      <span
                        className={`inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${
                          false
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {false ? (
                          <>
                            {" "}
                            <Plus className="w-3 h-3 " />{" "}
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          </>
                        ) : (
                          <>
                            <Minus className="w-3 h-3 " />{" "}
                            <ArrowDownRight className="w-3 h-3 mr-1" />
                          </>
                        )}
                        1.7
                      </span>

                      <span className="text-sm  font-normal text-black/60 leading-normal">
                        From the Current Month
                      </span>
                    </div>
                  )}
                </div>
                <CardContent>
                  {true ? (
                    <div className="flex flex-col gap-5  justify-center items-center pt-4 h-[300px]">
                      {/* row 1 */}
                      <div className="flex gap-4 w-full">
                        <div className="border border-[#E1E4EA] rounded-[10px] p-5 flex flex-col gap-3 w-full ">
                          <p className="text-2xl font-semibold text-[#0E121B]">
                            $250
                          </p>
                          <p className="text-sm  font-normal text-black/60">
                            From the last Month
                          </p>
                        </div>
                        <div className="border border-[#E1E4EA] rounded-[10px] p-5 flex flex-col gap-3 w-full ">
                          <p className="text-2xl font-semibold text-[#0E121B]">
                            $280
                          </p>
                          <p className="text-sm  font-normal text-black/60">
                            From the Sept Month
                          </p>
                        </div>
                      </div>

                      {/* row 2 */}
                      <div className="flex gap-4 w-full">
                        <div className="border border-[#E1E4EA] rounded-[10px] p-5 flex flex-col gap-3 w-full ">
                          <p className="text-2xl font-semibold text-[#0E121B]">
                            $180
                          </p>
                          <p className="text-sm  font-normal text-black/60">
                            From the Aug Month
                          </p>
                        </div>
                        <div className="border border-[#E1E4EA] rounded-[10px] p-5 flex flex-col gap-3 w-full ">
                          <p className="text-2xl font-semibold text-[#0E121B]">
                            $100
                          </p>
                          <p className="text-sm  font-normal text-black/60">
                            From the Apr Month
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              <div className="col-span-1 md:col-span-9  p-5 min-h-[400px] max-h-[450px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <CardTitle className="flex items-center justify-between  overflow-hidden">
                  Deals
                  <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                    <DotsVerticalIcon />
                  </div>
                </CardTitle>

                <DealList />
              </div>

              <Card className="col-span-1 md:col-span-3  p-5 min-h-[400px] max-h-[450px] border border-[#E1E4EA] shadow rounded-[10px]">
                
                 <CardHeader className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Sales Overview
                    <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                 
                </CardHeader>
                {/* <div className="my-6">
                  <div className="text-4xl font-medium text-[#0E121B]">
                    50,0000
                  </div>

                  {true && (
                    <div className="flex items-center  gap-1 mt-4">
                      <span
                        className={`inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full ${
                          true
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {true ? (
                          <>
                            {" "}
                            <Plus className="w-3 h-3 " />{" "}
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          </>
                        ) : (
                          <>
                            <Minus className="w-3 h-3 " />{" "}
                            <ArrowDownRight className="w-3 h-3 mr-1" />
                          </>
                        )}
                        2.7
                      </span>

                      <span className="text-sm  font-normal text-black/60 leading-normal">
                        Vs Last Month
                      </span>
                    </div>
                  )}
                </div> */}
                <CardContent>
                  {true ? (
                    <>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options}
                    />

                    <div className="flex flex-col gap-3">
                      <p className="text-sm font-semibold text-[rgba(14,18,27,0.40)]">Sales</p>

                      <div>
                        <div className="flex justify-between text-[#0E121B] text-sm font-medium items-center">
                          <p>$3459</p>
                          <p>Target: $100000</p>
                        </div>
                        <div className="flex gap-1 items-center">
                    <div className="w-full h-2 bg-gray-200 ">
                      <div
                        className="h-2 bg-yellow-400 "
                        style={{ width: `${34}%` }}
                      ></div>
                    </div>
                  </div>

                      </div>
                    </div>
                    
                    </>
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

              {/* Top Accounts */}
              <Card className="col-span-1 md:col-span-4  p-5 min-h-[450px] max-h-[500px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <div className="flex flex-col gap-[20px] w-full overflow-hidden">
                  <CardTitle className="flex items-center justify-between">
                    Total Income
                    <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>

                  <div className="flex flex-col gap-[20px] w-full overflow-x-hidden overflow-y-auto">
                    {[1, 2, 3, 4].map((each, idx) => {
                      const isOpen = openAccountIndex === idx;

                      return (
                        <div
                          className={`p-5 rounded-[5px] border border-[#E1E4EA]  shadow hover:shadow-lg transition-all duration-300   flex flex-col gap-y-[14px] bg-[${
                            isOpen ? "#fff" : "#F5F7FA"
                          }]`}
                        >
                          <div className="flex flex-col gap-1">
                            <div className="flex justify-between items-center">
                              <p className="text-[16px] font-semibold text-[#0E121B]">
                                Thomas Mentelos
                              </p>

                              <ChevronDown
                                className={`w-5 h-5 bg-white rounded-full transition-transform duration-200 cursor-pointer ${
                                  isOpen ? "rotate-180" : ""
                                }`}
                                onClick={() =>
                                  setOpenAccountIndex(isOpen ? null : idx)
                                }
                              />
                            </div>

                            <div className="flex justify-between items-center">
                              <a
                                href={`mailto:abc@gmail.com`}
                                className="flex gap-1 items-center text-xs font-medium"
                              >
                                <Mail className="h-4 w-4" /> abc@gmail.com
                              </a>
                              <a
                                href={`tel:12345678`}
                                className="flex gap-1 items-center text-xs font-medium"
                              >
                                <PhoneCall className="h-4 w-4" />{" "}
                                (305)-46291717-1{" "}
                              </a>
                            </div>
                          </div>

                          {isOpen && (
                            <>
                              <div className="flex justify-between items-center">
                                <span className="text-sm text-red-500">
                                  Deadline Missed
                                </span>
                                <span>
                                  <StatusChip
                                    color={
                                      "active" == "active"
                                        ? "green"
                                        : "active" == "pending"
                                        ? "blue"
                                        : "red"
                                    }
                                  >
                                    Active
                                  </StatusChip>
                                </span>
                              </div>

                              <div className="grid grid-cols-4 gap-[10px]  h-full">
                                <div className="px-[10px] py-[15px] border border-[#E1E4EA] rounded-[10px] flex flex-col gap-[10px] justify-between items-center">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.40)] text-center">
                                    Total Paid Transaction
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    $18,000
                                  </p>
                                </div>
                                <div className="px-[10px] py-[15px] border border-[#E1E4EA] rounded-[10px] flex flex-col gap-[10px] justify-between items-center">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.40)] text-center">
                                    Total UnPaid Transaction
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    $15,000
                                  </p>
                                </div>
                                <div className="px-[10px] py-[15px] border border-[#E1E4EA] rounded-[10px] flex flex-col gap-[10px] justify-between items-center">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.40)] text-center">
                                    No of Projects
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    $15,000
                                  </p>
                                </div>
                                <div className="px-[10px] py-[15px] border border-[#E1E4EA] rounded-[10px] flex flex-col gap-[10px] justify-between items-center">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.40)] text-center">
                                    No. of Deals Won
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    $12,000
                                  </p>
                                </div>
                              </div>

                              <div className="flex  gap-1 items-center">
                                {/* Users initials */}
                                <div className="flex -space-x-1">
                                  {Array.isArray(users) && users?.length > 0 ? (
                                    <div className="flex items-center">
                                      {visibleUsers?.map((each, idx) => (
                                        <Tooltip
                                          key={idx}
                                          content={each?.name}
                                          position="top center"
                                        >
                                          <div
                                            className={`relative ${
                                              idx !== 0 ? "-ml-2" : ""
                                            }`} // overlap but prevent transparency blend
                                            onClick={
                                              visibleUsers.length - 1 == idx
                                                ? () => setShowAll(false)
                                                : null
                                            }
                                          >
                                            {each?.userimg ? (
                                              <img
                                                src={each?.userimg}
                                                alt={each.name}
                                                className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.style.display =
                                                    "none";
                                                  const fallback =
                                                    document.createElement(
                                                      "div"
                                                    );
                                                  fallback.className =
                                                    "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                  fallback.innerText = (
                                                    (each?.name?.split(
                                                      " "
                                                    )[0]?.[0] || "") +
                                                    (each?.name?.split(
                                                      " "
                                                    )[1]?.[0] || "")
                                                  ).toUpperCase();
                                                  e.target.parentElement.appendChild(
                                                    fallback
                                                  );
                                                }}
                                              />
                                            ) : (
                                              <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                {(each?.name?.split(
                                                  " "
                                                )[0]?.[0] || "") +
                                                  (each?.name?.split(
                                                    " "
                                                  )[1]?.[0] || "")}
                                              </div>
                                            )}
                                          </div>
                                        </Tooltip>
                                      ))}

                                      {/* Show +N if there are hidden users */}
                                      {!showAll && hiddenCount > 0 && (
                                        <div
                                          className="-ml-2 z-10 h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 text-white text-xs font-medium border-2 border-white shadow-sm cursor-pointer"
                                          onClick={() => setShowAll(true)}
                                        >
                                          <Tooltip
                                            content="see all users"
                                            position="top center"
                                          >
                                            +{hiddenCount}
                                          </Tooltip>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="text-gray-400 text-sm">
                                      -
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Card>

              {/* To dos */}
              <Card className="col-span-1 md:col-span-4  p-5 min-h-[450px] max-h-[500px] border border-[#E1E4EA] shadow rounded-[10px] overflow-hidden">
                <div className="flex flex-col gap-[20px] w-full overflow-hidden">
                  <CardTitle className="flex items-center justify-between">
                    Total Dos
                    <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>

                  <div className="flex flex-col gap-[20px] w-full overflow-x-hidden overflow-y-auto">
                    {[1, 2, 3, 4].map((each, idx) => {
                      const isOpen = openTodoIndex === idx;

                      return (
                        <div
                          className={`p-5 rounded-[5px] border border-[#E1E4EA] shadow hover:shadow-lg transition-all duration-300  flex flex-col gap-y-[14px] bg-[${
                            isOpen ? "#fff" : "#F5F7FA"
                          }]`}
                        >
                          <div className="flex flex-col gap-1">
                            <div className="flex justify-between items-center">
                              <p className="text-[16px] font-semibold text-[#0E121B]">
                                Thomas Mentelos
                              </p>

                              <ChevronDown
                                className={`w-5 h-5 bg-white rounded-full transition-transform duration-200 cursor-pointer ${
                                  isOpen ? "rotate-180" : ""
                                }`}
                                onClick={() =>
                                  setOpenTodoIndex(isOpen ? null : idx)
                                }
                              />
                            </div>

                            <div className="flex justify-between items-center">
                              <a
                                href={`mailto:abc@gmail.com`}
                                className="flex gap-1 items-center text-xs font-medium"
                              >
                                <Mail className="h-4 w-4" /> abc@gmail.com
                              </a>
                              <a
                                href={`tel:12345678`}
                                className="flex gap-1 items-center text-xs font-medium"
                              >
                                <PhoneCall className="h-4 w-4" />{" "}
                                (305)-46291717-1{" "}
                              </a>
                            </div>
                          </div>

                          {isOpen && (
                            <>
                              <div className="grid grid-cols-4 gap-[10px]  h-full">
                                <div className="p-2   border-r-2 border-r-[#E1E4EA]  flex flex-col gap-1 justify-center items-start">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.60)] text-center">
                                    Package Type
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    Best Seller
                                  </p>
                                </div>
                                <div className="p-2   border-r-2 border-r-[#E1E4EA]  flex flex-col gap-1 justify-center items-start">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.60)] text-center">
                                    Project Cost
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    $1500
                                  </p>
                                </div>

                                <div className="p-2   border-r-2 border-r-[#E1E4EA]  flex flex-col gap-1 justify-center items-start">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.60)] text-center">
                                    Project Started
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    02-8-2025
                                  </p>
                                </div>
                                <div className="p-1     flex flex-col gap-1 justify-center items-start">
                                  <p className="text-xs font-medium text-[rgba(14,18,27,0.60)] text-center">
                                    Account
                                  </p>
                                  <p className="text-[18px] font-semibold">
                                    Alice
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Card>

              {/* Favourites */}
              <Card className="col-span-1 md:col-span-4  p-5 min-h-[450px] max-h-[500px] border border-[#E1E4EA] shadow rounded-[10px]">
                <div className="flex flex-col">
                  <CardTitle className="flex items-center justify-between">
                    Total Income
                    <div>
                      <DotsVerticalIcon />
                    </div>
                  </CardTitle>
                </div>

                <CardContent>
                  {true ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={totalIncomeOptions}
                    />
                  ) : (
                    <InnerLoader />
                  )}
                </CardContent>
              </Card>

             
            </div>
          </TableCard>
        </div>
      </div>
    </>
  );
};

export default TeamDashbaord;
